import React, { Component } from "react";
import { ModuleAccordionGroup } from '@loanbossinc/component-library';
import { AccordionSection } from "component-lib/AccordionSection";
import { rows as sectionPropertyIndividualOwnerRows } from './section-property-individual-owner-rows';
import { rows as sectionPropertyCompanyOwnerRows } from './section-property-company-owner-rows';
import { PROPERTY_SECTION_KEYS } from '../property.constants';


export class PropertyOwnership extends Component {
  addIndividualOwnerButton = {
    key: 'add-an-individual-owner'
    , buttonLabel: 'Add an individual owner'
    , isButton: true
    , showEditButton: true
    , onClick: () => {
      this.props.newItem({
        propertyId:this.props.data.id,
        principleType: 'individual',
        callback: () => this.props.history.push(`/properties/${this.props.data.id}/edit/${PROPERTY_SECTION_KEYS.INDIVIDUAL_OWNERS}`)
      })
    }
  }

  addCompanyOwnerButton = {
    key: 'add-an-individual-owner'
    , buttonLabel: 'Add a company owner'
    , isButton: true
    , showEditButton: this.props.enableEditOwnershipCompanyButton
    , onClick: () => {
      this.props.newItem({
        propertyId:this.props.data.id,
        principleType: 'company',
        callback: () => this.props.history.push(`/properties/${this.props.data.id}/edit/${PROPERTY_SECTION_KEYS.COMPANY_OWNERS}`)
      })
    }
  }

  getIndividualOwnerGroup = () => {
    const { data, id, history, enableEditButton, propertyId } = this.props;
    if ((!data || !data.individualOwners || data.individualOwners.length === 0) && enableEditButton) 
      return this.addIndividualOwnerButton;

    return {
      title: 'Individual Owners'
      , key: PROPERTY_SECTION_KEYS.INDIVIDUAL_OWNERS
      , isExpandable: true
      , isTitleGroup: false
      , buttonLabel: 'Edit Details'
      , showEditButton: enableEditButton
      , onClick: () => history.push(`/properties/${propertyId}/edit/${PROPERTY_SECTION_KEYS.INDIVIDUAL_OWNERS}`)
      , sections: [
        <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionPropertyIndividualOwnerRows} data={data} />
      ]
    }
  }

  getCompanyOwnerGroup = () => {
    const { data, history, enableEditButton, propertyId, enableEditOwnershipCompanyButton } = this.props;
    
    if ((!data || !data.companyOwners || data.companyOwners.length === 0) && enableEditButton ) 
      return this.addCompanyOwnerButton;

    return {
      title: 'Company Owners'
      , key: PROPERTY_SECTION_KEYS.COMPANY_OWNERS
      , isExpandable: true
      , isTitleGroup: false
      , buttonLabel: 'Edit Details'
      , showEditButton: enableEditOwnershipCompanyButton
      , onClick: () => history.push(`/properties/${propertyId}/edit/${PROPERTY_SECTION_KEYS.COMPANY_OWNERS}`)
      , sections: [
        <AccordionSection eventHandlers={this.props.eventHandlers} rows={sectionPropertyCompanyOwnerRows} data={data} />
      ]
    }
  }

  render() {
    const { data, ...other } = this.props;
    if (!data) return null;

    return (
      <ModuleAccordionGroup
        {...other}
        groups={[
          {
            title: 'Ownership'
            , key: 'ownership'
            , isExpandable: false
            , isTitleGroup: true
          }
          , this.getIndividualOwnerGroup()
          , this.getCompanyOwnerGroup()
        ]}
      />
    );
  }
}
